import { UserManagerSettings } from 'oidc-client-ts';

const appUrl =
  process.env.REACT_APP_URL ||
  `${window.location.protocol}//${window.location.hostname}`;

const authorityUrl =
  process.env.REACT_APP_AUTHORITY ||
  `${window.location.protocol}//auth.${window.location.hostname}`;
const clientId = process.env.REACT_APP_ZITADEL_CLIENT_ID;

if (!clientId) {
  console.error(
    'REACT_APP_ZITADEL_CLIENT_ID is not set. Please create .env file with REACT_APP_ZITADEL_CLIENT_ID',
  );
}

if (!authorityUrl || authorityUrl.includes('auth.localhost')) {
  console.warn(
    'REACT_APP_AUTHORITY is not set or using default. Current authority:',
    authorityUrl,
    'Please set REACT_APP_AUTHORITY in your .env file.',
  );
}

const authConfig: UserManagerSettings = {
  authority: authorityUrl,
  redirect_uri: `${appUrl}/auth`,
  post_logout_redirect_uri: `${appUrl}`,
  scope: 'openid email profile',
  client_id: clientId,
  response_type: 'code',
  response_mode: 'query',
};

export default authConfig;
